<template>
    <v-row style="max-width: 600px; margin: 0 auto;" :style="{ 'background-color': $store.state.colors.primary }" >
        <v-col id="base" md="12" style="height: 100%; position:fixed; max-width: 600px;" :style="{ 'background-color': $store.state.colors.primary }" class="mt-0 pt-0" >
            <!-- Logo -->
            <v-row justify="center" align="center" :style="{ 'background-color': $store.state.colors.primary }" class="pb-3">
                <v-img max-width="230px" height="80px" contain :src="$store.state.logoSRC"></v-img>
            </v-row>
            <v-row justify="center" align="center" style="color: white" class="pt-8">
                <v-col class="mt-0 pt-1 RestoRegular" style="font-size: 20px; text-align: center; line-height: 18px;">
                    <v-row justify="center" style="max-width: 240px; margin: 0 auto;"  >
                        Es un gusto tenerte con nosotros
                    </v-row>
                    <v-row justify="center" class="mt-2">
                        ¡Buen provecho!
                    </v-row>
                </v-col>
            </v-row>

            <v-row justify="center" align="center" class="pt-2" :style="{'background-image': 'url(' + require('@/assets/resources/yoomi/plecawelcome.png') + ')'}" style="background-repeat: no-repeat; background-size: cover; background-position: center; height: 70%; position: absolute; left: 12px; bottom: 1px; width: 100%; z-index: -10">
            </v-row>


            <!-- Button Continue -->
            <v-row justify="center" align="center" style="width: 100%; position: absolute; left: 0px; bottom: 5px; margin: 0 auto;" class="pt-0">
                <br><br><br>
                <v-btn @click="goToMenu()" class="text-left buttonLower" color="white" dark x-large style="width: 90%;  height: 60px; margin: 15px; " :style="{ 'color': $store.state.colors.primary }">
                    <span style="float: left; padding-left:0px;">Continuar</span>
                    <v-spacer></v-spacer>
                    <v-img max-width="20px" src="@/assets/resources/yoomi/arrow.png"></v-img>
                </v-btn>
            </v-row>
            

        </v-col>
    </v-row>
</template>


<script>
export default {
    created() {
            this.$store.state.logo = false;
        },
        methods:
        {
            goToMenu(){
                if(localStorage.getItem("id_sucursal") == "0")
                    this.$router.push({ name: 'select_delivery'});
                else
                {
                    localStorage.setItem("solo_sucursal", "N");
                    this.$router.push({ name: 'menu'});
                }
            }
        }
}
</script>

<style scoped>

</style>